import { computed, ref, watch } from 'vue'
import Validator from '@app/helpers/validator/validator'
import { createAsyncApi } from '../partials/async'
import { dataGet } from '../../helpers/dot'

export function createForm(initialValues = {}, submissionAction, submissionConfig = {}) {
    const fields = ref(initialValues)

    const validator = function (rules, values, debug = false) {
        return (new Validator(rules, values ?? fields.value, debug)).validate()
    }

    const submissionApi = createAsyncApi(
        submissionAction,
        'POST',
        submissionConfig
    )

    const data = computed(() => fields.value)

    const setProgress = async (progress) => {
        data.value = progress

        return true
    }

    const applyDataForSubmission = (submissionData) => {
        submissionApi.api.parameters.value = submissionConfig?.parameters !== undefined
            ? {
                ...submissionConfig?.parameters,
                ...submissionData
            } : submissionData
    }

    const unwatchData = watch(data, applyDataForSubmission, { deep: true, immediate: true })

    const errors = computed(() => {
        return Object.keys(submissionApi.errors.value)
            .reduce((errors, field) => {
                if (dataGet(field, submissionApi.api.sentData.value) == dataGet(field, data.value)) {
                    errors[field] = submissionApi.errors.value[field]
                }

                return errors
            }, {})
    })


    return {
        /**
         * All the field data for this state
         */
        fields: fields,

        /**
         * The callback to run to validate a given set of fields
         */
        validator: validator,

        /**
         * Handles setting the progress from the form if we want to reload it
         */
        setProgress: setProgress,

        /**
         * The data the form is currently submitting
         */
        data: data,

        /**
         * The submission errors
         */
        errors: errors,

        /**
         * Checks if the current field has errors
         * 
         * @param {Array} fieldNames 
         * @returns {Boolean}
         */
        hasErrors: (fieldNames) => {
            return fieldNames.some((fieldName) => errors.value[fieldName] !== undefined)
        },

        /**
         * Applies a new set of data to the submission api
         * 
         * @param {Object} submissionData 
         */
        applyDataForSubmission: applyDataForSubmission,

        actions: {
            /**
             * Save a new membership
             */
            submit: submissionApi,

            /**
             * Removes a watch from the data (used by multistep forms)
             */
            removeDataWatch: unwatchData
        }
    }
}